import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { UsersModule } from '../../../users/users.module';

interface Params extends ICellRendererParams {
  analystTooCloseToSelf: Promise<boolean>;
}

@Component({
  standalone: true,
  imports: [UsersModule],
  template: `
    @if (userId) {
      <app-user-avatar [class.warn]="analystTooCloseToSelf" [userId]="userId" />
    }
  `,
  styles: `
    app-user-avatar.warn {
      color: red !important;
    }
  `,
})
export class AnalystRendererComponent implements ICellRendererAngularComp {
  analystTooCloseToSelf = false;
  userId: string;

  agInit(params: Params) {
    params.analystTooCloseToSelf.then((v) => (this.analystTooCloseToSelf = v));
    this.userId = params.value;
  }

  refresh(params: Params) {
    this.agInit(params);
    return true;
  }
}
